// @material-ui/icons
import Email from "@material-ui/icons/Email";
import Audit from "@material-ui/icons/TrackChanges";
import AirlineRouteIcon from "@material-ui/icons/Flight";
import Landing from "@material-ui/icons/FlightLandOutlined";
import Settings from "@material-ui/icons/SettingsApplications";

import MainLandingPage from "../layouts/Landing/RegionalLanding/landing";
import NotFound from "views/NotFound/Index.jsx";

import SettingsPage from "Regional-Views/Settings/Index.jsx";
import EmailSettings from "Regional-Views/EmailSettings/Index.jsx";
import ExchangeRateAirlineView from "Regional-Views/ExchangeRateAirline/airlineView.js";
import BillablePscSettings from "Regional-Views/BillablePscSettings/Index.jsx"
import HelpCenter from "../Regional-Views/HelpCenter/index"
import HelpIcon from "@material-ui/icons/HelpOutline"

// These routes are used by ICT Unit mapped to Faan Admin role
const routes = [
  {
    path: "/main-landing",
    sidebarName: "Main Landing",
    navbarName: "Main Landing",
    icon: Landing,
    component: MainLandingPage,
    subMenu: [],
  },
  {
    path: "/app/settings",
    sidebarName: "Settings",
    navbarName: "Settings",
    subMenu: [
      {
        path: "/app/psc-regional/settings",
        sidebarName: "Re-order Level",
        navbarName: "Re-order Level",
        component: SettingsPage
      },
      {
        path: "/app/psc-regional/emailSettings",
        sidebarName: "Email Settings",
        navbarName: "Email Settings",
        icon: Email,
        component: EmailSettings
      },
      {
        path: "/app/psc-regional/billableSettings",
        sidebarName: "Billable Passenger",
        navbarName: "Billable Passenger Settings",
        icon: AirlineRouteIcon,
        component: BillablePscSettings,
    
      },
    ],
    icon: Settings,
    component: SettingsPage
  },
  {
    path: "/app/psc-regional/settings",
    sidebarName: "Re-order Level",
    navbarName: "Re-order Level",
    isNotVisible: true,
    component: SettingsPage,
    subMenu: [],
    
  },
  {
    path: "/app/psc-regional/emailSettings",
    sidebarName: "Email Settings",
    navbarName: "Email Settings",
    icon: Email,
    isNotVisible: true,
    component: EmailSettings,
    subMenu: [],
  },
  {
    path: "/app/psc-regional/billableSettings",
    sidebarName: "Billable Passenger",
    navbarName: "Billable Passenger Settings",
    icon: AirlineRouteIcon,
    component: BillablePscSettings,
    isNotVisible: true,
    subMenu: [],
  },
  {
    path: "/app/psc-regional/exchange-rate",
    sidebarName: "Exchange Rate",
    navbarName: "Exchange Rate",
    icon: AirlineRouteIcon,
    subMenu: [],
    component: ExchangeRateAirlineView,
  },
  {
    path: "/app/psc-regional/help-center",
    sidebarName: "Help Center",
    navbarName: "Help Center",
    icon: HelpIcon,
    component: HelpCenter,
    subMenu: []
  },
  {
    isNotVisible: true,
    path: "**",
    sidebarName: "Not found",
    navbarName: "Not Found",
    icon: Audit,
    subMenu: [],
    component: NotFound,
    
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/regional-faan-admin.jsx